import { p as parseChangeSet } from './parseChangeSet-03074a6b.js';

function changeSetHasField(changeSet, field) {
  const fieldPathes = field.split(".");
  let currentObj = changeSet;
  return fieldPathes.every((path) => {
    const objHasPath = Object.keys(currentObj).includes(path);
    if (objHasPath) {
      currentObj = currentObj[path];
    }
    return objHasPath;
  });
}

function getDocumentValue(document, field, nullIfNonExistent = false) {
  let value = document;
  field.split(".").forEach((segment) => {
    if (value) {
      value = value[segment];
    }
  });
  if (!value) {
    return nullIfNonExistent ? null : [];
  }
  if (!Array.isArray(value)) {
    return [value];
  }
  return value;
}

const validatePermission = (documentValue, permission, comparisonType) => {
  const documentHasValues = documentValue?.length;
  if (!documentHasValues) {
    return false;
  }
  if (comparisonType === "all") {
    return documentValue.every((value) => {
      return permission.some((accessSiteId) => `${value}` === `${accessSiteId}`);
    });
  }
  return documentValue.some((value) => {
    return permission.some((accessSiteId) => `${value}` === `${accessSiteId}`);
  });
};
const validateDocument = (document, permission, changeSet, field) => {
  const documentValue = getDocumentValue(document, field, !changeSet);
  const changeSetValue = changeSet ? getDocumentValue(changeSet, field) : null;
  if (!changeSet && !Array.isArray(documentValue)) {
    return true;
  }
  const changeSetHasValues = !!changeSet && Array.isArray(changeSetValue);
  return validatePermission(
    documentValue,
    permission,
    // all: if the changeSet is updating the field itself, we need to ensure that the document values
    //  match ALL values that the user has access to
    //  this prevents overwriting values that we cannot read
    // any: if the changeSet is not updating the field, then if any of the values match the values the
    //  user has access to, we can already allow editing since there's no risk of replacing an
    //  existing value
    changeSetHasValues ? "all" : "any"
  );
};
const canUpdateDocuments = async (Runtime, filter, changeSet, collection, field, documentsToValidate) => {
  const organisationUser = Runtime.getOrganisationData(filter.organisation);
  const parsedChangeSet = parseChangeSet(changeSet);
  const canReadAccessSite = Runtime.userHasAllScopes(
    filter.organisation.toString(),
    null,
    "accessSite.read"
  );
  if (!canReadAccessSite) {
    return !changeSetHasField(parsedChangeSet, field);
  }
  const { customPermissions = {} } = organisationUser;
  const { accessSites = [] } = customPermissions;
  if (!accessSites?.length) {
    return true;
  }
  let documents = documentsToValidate;
  if (!documents) {
    documents = await Runtime.db.collection(collection).find(filter, {
      projection: {
        [field]: 1
      }
    }).toArray();
  }
  const documentsAreValid = documents.every((document) => {
    return validateDocument(document, accessSites, parsedChangeSet, field);
  });
  if (!documentsAreValid) {
    return false;
  }
  return validateDocument(parsedChangeSet, accessSites, null, field);
};

const canInsertDocument = (Runtime, document, field) => {
  const organisationUser = Runtime.getOrganisationData(document.organisation);
  const canReadAccessSite = Runtime.userHasAllScopes(
    document.organisation.toString(),
    null,
    "accessSite.read"
  );
  if (!canReadAccessSite) {
    return !changeSetHasField(document, field);
  }
  const { customPermissions = {} } = organisationUser;
  const { accessSites = [] } = customPermissions;
  if (!accessSites?.length) {
    return true;
  }
  const documentValue = getDocumentValue(document, field);
  const documentHasValues = documentValue?.length;
  if (!documentHasValues) {
    return false;
  }
  const cannotAccessAnySite = documentValue.some((documentAccessSiteId) => {
    return !accessSites.some((accessSiteId) => `${documentAccessSiteId}` === `${accessSiteId}`);
  });
  if (cannotAccessAnySite) {
    return false;
  }
  return true;
};

const canRemoveDocuments = async (Runtime, filter, collection, field, documentsToValidate) => {
  const organisationUser = Runtime.getOrganisationData(filter.organisation);
  if (!Runtime.userHasAllScopes(filter.organisation.toString(), null, "accessSite.read")) {
    return true;
  }
  const { customPermissions = {} } = organisationUser;
  const { accessSites = [] } = customPermissions;
  if (!accessSites?.length) {
    return true;
  }
  let documents = documentsToValidate;
  if (!documents) {
    documents = await Runtime.db.collection(collection).find(filter, {
      projection: {
        [field]: 1
      }
    }).toArray();
  }
  return documents.every((document) => {
    const documentValue = getDocumentValue(document, field);
    const documentHasValues = documentValue?.length;
    if (!documentHasValues) {
      return false;
    }
    return documentValue.some((documentAccessSiteId) => {
      return accessSites.some((accessSiteId) => `${documentAccessSiteId}` === `${accessSiteId}`);
    });
  });
};

export { canRemoveDocuments as a, canUpdateDocuments as b, canInsertDocument as c, getDocumentValue as g };
//# sourceMappingURL=canRemoveDocuments-3b897618.js.map
